module.exports = __webpack_public_path__ + "static/media/dc-1.f0b58a58.png";